module.exports = __webpack_public_path__ + "img/icon19.922da0c2.png";